var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-tile-item"},[_c('v-img',{attrs:{"src":_vm.imgSrc}}),_vm._v(" "),_c('div',{staticClass:"button-tile-content"},[_c('h1',{staticClass:"title-info"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }